import * as R from 'ramda';

import { TReduxActions } from '../../types/redux';
import { IFiltersState } from '../../types/filters';
import { FILTERS, IFilter } from '../../constants/filters';
import { defaultState } from './defaultState';

export function clearReducer(state: IFiltersState = defaultState, action: TReduxActions): IFiltersState {
  if (action.type.startsWith('filters/')) {
    const { jsonQuery } = state;

    let nextJsonQuery = R.clone(jsonQuery);
    Object.values(FILTERS).forEach((filter: IFilter) => {
      if (filter.clear && !filter.availability(nextJsonQuery)) {
        nextJsonQuery = filter.clear(nextJsonQuery);
      }
    });

    return {
      ...state,
      jsonQuery: nextJsonQuery,
    };
  }

  return state;
}
